import React from "react";
import { RateByType, TimeProfileType, } from "store/recipe/recipe.types";
import { findDictionaryItemByValue, rampTypes, timeChangeTypes, timeProfileTypes } from "shared/rsDictionary";
import { getComplexValueStepText } from "../../../ComplexValueParameter/utils";
export const getTimeProfileStepText = (value, parameters, customVariables, prefix) => {
    const typeLabel = findDictionaryItemByValue(timeProfileTypes, value?.type)?.label;
    if (!typeLabel) {
        return;
    }
    const baseLabel = (React.createElement(React.Fragment, null,
        prefix,
        prefix && React.createElement("span", null, " "),
        typeLabel));
    switch (value?.type) {
        case TimeProfileType.BOLUS:
            return baseLabel;
        case TimeProfileType.CONSTANT_RATE: {
            const { rateByProperties } = value;
            if (!rateByProperties?.type) {
                return;
            }
            switch (rateByProperties?.type) {
                case RateByType.BY_RATE:
                    return getComplexValueStepText({
                        value: rateByProperties?.rate,
                        parameters,
                        customVariables,
                        prefix: baseLabel,
                    });
                case RateByType.BY_TIME:
                    return getComplexValueStepText({
                        value: rateByProperties?.forTime,
                        parameters,
                        customVariables,
                        prefix: baseLabel,
                        infiniteProps: { withPrefix: true },
                    });
                default:
                    return;
            }
        }
        case TimeProfileType.RAMP: {
            const { timeChangeType, value: rampValue, startRate } = value;
            const timeChangeTypeLabel = findDictionaryItemByValue(timeChangeTypes, timeChangeType)?.label;
            const rampValueTypeLabel = findDictionaryItemByValue(rampTypes, rampValue?.type)?.label;
            if (!timeChangeTypeLabel || !rampValueTypeLabel) {
                return;
            }
            const startRateLabel = getComplexValueStepText({
                value: startRate,
                parameters,
                customVariables,
                prefix: (React.createElement(React.Fragment, null,
                    baseLabel,
                    ", ",
                    timeChangeTypeLabel)),
            });
            if (!startRateLabel) {
                return;
            }
            return getComplexValueStepText({
                value: rampValue?.value,
                parameters,
                customVariables,
                prefix: (React.createElement(React.Fragment, null,
                    startRateLabel,
                    " based on ",
                    rampValueTypeLabel.toLowerCase())),
            });
        }
        default:
            return;
    }
};
